import { getStore } from "@/store/index";

// 获取csr实例
export const useCsrVm = (id) => {
    const { cacheCsrCmpVm = {} } = window
    // 初始化实例时，已将实例挂载在window.cacheCsrCmpVm上，此处直接返回即可
    return cacheCsrCmpVm[id];
}

// 缓存csr实例
export const useCacheCsrVm = (id, vm) => {
    window.cacheCsrCmpVm ??= {};
    window.cacheCsrCmpVm[id] = vm;
}

// 卸载csr实例
export const useDestoryCsrVm = (id) => {
    // 1.卸载vm
    useCsrVm(id).$destroy();
    // 2.在store中删除state
    const store = getStore();
    store.delCsrState(id);
    // 3.删除window中的缓存
    delete window.cacheCsrCmpVm[id];
}